import Theme from "@amzn/meridian/theme";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";

const BorderColorOutlineToken = ({ children, color }) => {
  const themeShadow = {
    ...blueLightTokens, // use meridian's default tokens as a starting point and then override as necessary
    boxBorderColorOutline: color,
  };

  return <Theme tokens={themeShadow}>{children}</Theme>;
};

export default BorderColorOutlineToken;